/**
 * Utility functions for session storage operations
 */

/**
 * Retrieves the contextId from sessionStorage with detailed logging
 * @returns The contextId string if found, null otherwise
 */
export function getContextId(): string | null {
  console.log('🔍 Starting contextId retrieval...');
  console.log('🔍 Window available:', typeof window !== 'undefined');
  console.log('🔍 SessionStorage available:', typeof window !== 'undefined' && window.sessionStorage);
  
  let contextId: string | null = null;
  if (typeof window !== 'undefined' && window.sessionStorage) {
    console.log('🔍 Attempting to get contextId from sessionStorage...');
    contextId = sessionStorage.getItem('contextId');
    console.log('🔍 Retrieved contextId from sessionStorage:', contextId);
    
    // Debug: log all sessionStorage keys and values
    console.log('🔍 All sessionStorage keys:', Object.keys(sessionStorage));
    console.log('🔍 All sessionStorage contents:');
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      const value = sessionStorage.getItem(key || '');
      console.log(`   ${key}: ${value}`);
    }
  } else {
    console.error('❌ SessionStorage not available');
  }
  
  return contextId;
}